@if (stream$ | async; as stream) {
    <h1 mat-dialog-title>Upload Details</h1>
    <div mat-dialog-content>
        <form [formGroup]="form" class="flex column align-items-stretch">
            @for (uploadForm of uploads.controls; track uploadForm; let i = $index) {
                <div
                    class="flex row align-space-between justify-stretch item-row"
                    [formGroup]="uploadForm"
                >
                    <div class="flex column align-space-between justify-stretch preview-wrapper">
                        @if (previews[i]) {
                            <img
                                class="preview"
                                src="{{ previews[i] }}"
                                (error)="previews[i] = null"
                            />
                        }
                    </div>
                    <div class="flex column align-space-between justify-stretch form-data">
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" />
                        </mat-form-field>
                        <div class="wide markdown">
                            <frog-markdown-textarea
                                formControlName="description"
                            ></frog-markdown-textarea>
                            <small align="end" class="slack-limit"
                                >Slack Limit: {{ uploadForm.value.description.length }} /
                                {{ slackLimit }}</small
                            >
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
            <div class="tag-list">
                <mat-chip-listbox>
                    @for (tag of tags; track tag) {
                        <mat-chip-option [removable]="true" (removed)="removeTag(tag)">
                            {{ tag.displayName }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>
            <frog-tag-input
                (OnSelect)="addTag($event)"
                placeholder="Add Tag"
                actionPrefix="Add"
            ></frog-tag-input>
            @if (uploads.controls.length > 1) {
                <mat-checkbox formControlName="group">
                    Group Uploads
                    <a matTooltip="Group all uploads as a grouped asset">[?]</a>
                </mat-checkbox>
            }
            <p></p>
        </form>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button color="primary" (click)="save(stream)" [disabled]="loading">
            Upload
        </button>
    </div>
}
